import { Box, BoxProps, Stack, Typography } from '@mui/material';
import React, { FC } from 'react';

import { AppDate, formatDate } from '../formatUtils/dateFormatUtils';

export interface PlainEntityDetailsHeaderProps {
  title: React.ReactNode;
  createdAt: AppDate;
  updatedAt: AppDate;
  containerBoxProps?: BoxProps;
}

export const PlainEntityDetailsHeader: FC<PlainEntityDetailsHeaderProps> = props => (
  <Box sx={{ display: 'flex', justifyContent: 'space-between' }} {...props.containerBoxProps}>
    <Typography variant="h4" sx={{ mb: 1 }}>
      {props.title}
    </Typography>
    <Box sx={{ paddingRight: '2rem' }}>
      <Stack
        direction="row"
        sx={{
          alignItems: 'center',
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            color: 'text.secondary',
            width: 150,
          }}
        >
          angelegt am
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{
            color: 'text.secondary',
          }}
        >
          {formatDate(props.createdAt)}
        </Typography>
      </Stack>
      <Stack
        direction="row"
        sx={{
          alignItems: 'center',
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            color: 'text.secondary',
            width: 150,
          }}
        >
          zuletzt geändert am
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{
            color: 'text.secondary',
          }}
        >
          {formatDate(props.updatedAt)}
        </Typography>
      </Stack>
    </Box>
  </Box>
);
